import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type LocalCustomerManagementModuleSpecsFragment } from '../../../../../api/fragments/LocalCustomerManagementModuleSpecs';
import {
    CreateLocalCustomerManagementDocument,
    type CreateLocalCustomerManagementMutation,
    type CreateLocalCustomerManagementMutationVariables,
} from '../../../../../api/mutations/createLocalCustomerManagement';
import { type LocalCustomerManagementSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import LocalCustomerModulePage, { type LocalCustomerModulePageProps } from '../../LocalCustomerModuleDetailPage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<
    LocalCustomerManagementModuleSpecsFragment,
    LocalCustomerManagementSettings
> = {
    PageComponent: ({ module }: LocalCustomerModulePageProps) => <LocalCustomerModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.LocalCustomerManagementModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateLocalCustomerManagementMutation, CreateLocalCustomerManagementMutationVariables>({
                mutation: CreateLocalCustomerManagementDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
